module.exports = __webpack_public_path__ + "static/media/logo.38f4ec9d.png";